import VueCookies from 'vue-cookies'

export default {
  data() {
    return {
      useSavedFilters: false
    }
  },
  methods: {
    saveFilters(filtersName, values) {
      let filters = VueCookies.get(filtersName)

      if (JSON.stringify(filters) != values) {
        VueCookies.set(filtersName, values, '5min')
      }
    },
    getFilters(filtersName) {
      let filters = VueCookies.get(filtersName)

      return filters ? filters : null
    },
    stringify(obj) {
      let cache = [];

      let str = JSON.stringify(obj, function(key, value) {
        if (typeof value === 'object' && value !== null) {
          if (cache.indexOf(value) !== -1) {
            return;
          }

          cache.push(value);
        }
        return value;
      });
      cache = null;

      return str;
    },
    dateConvert(start, end) {
      if (!start || !end) {

        return {
          startDate: null,
          endDate: null
        }
      }

      let startDate = new Date(start);
      let endDate = new Date(end);

      let startDateConverted = new Date(Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0))
      let endDateConverted = new Date(Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 0, 0))

      return {
        startDate: startDateConverted,
        endDate: endDateConverted
      };
    },
  }
}



// WEBPACK FOOTER //
// ./resources/js/views/front/mixins/saveFiltersMixin.js